module.exports = {"220174001":"锦程街道","220174002":"东风街道","220174003":"富民街道","220174004":"前程街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220174.json
// module id = 702
// module chunks = 0